"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LoyaltyDialogController = require("./LoyaltyDialogController");
Object.keys(_LoyaltyDialogController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoyaltyDialogController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoyaltyDialogController[key];
    }
  });
});
